import { useMemo } from 'react';
import { GeneDataMap, SearchMode } from '../_types';
import { getGeneNameDataBySearchTerm, Trie } from '../_utils';

interface UseSearchFilteredGenesProps {
  searchTerm: string;
  allGeneData: {
    geneDataMap: GeneDataMap;
    geneTrie: Trie;
  };
  hasSearched: boolean;
  searchMode: SearchMode;
}

/**
 * 검색어를 기반으로 유전자 데이터를 필터링하는 커스텀 훅
 *
 * @param searchTerm 검색어
 * @param allGeneData 모든 유전자 데이터
 * @param hasSearched 검색 버튼 클릭 여부
 * @param searchMode 검색 모드 (Genes: 접두사 검색, Panel: 정확한 일치)
 * @returns 필터링된 유전자 데이터와 유효하지 않은 유전자 이름 목록
 */
export function useSearchFilteredGenes({
  searchTerm,
  allGeneData,
  hasSearched,
  searchMode,
}: UseSearchFilteredGenesProps) {
  return useMemo(() => {
    return getGeneNameDataBySearchTerm(
      searchTerm,
      allGeneData.geneDataMap,
      allGeneData.geneTrie,
      hasSearched,
      searchMode,
    );
  }, [searchTerm, allGeneData, hasSearched, searchMode]);
}
